import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { PromoCodeEffects, promoCodeFeatureKey, promoCodeReducer } from '@store/promocode';
import { PromoCodeRepository } from '@core/repositories/promocode.repository';
import { PromoCodeWebRepository } from '@data/repositories/promocode-web.repository';



@NgModule({
  imports: [
    StoreModule.forFeature(promoCodeFeatureKey, promoCodeReducer),
    EffectsModule.forFeature([ PromoCodeEffects ]),
  ],
  providers: [
    { provide: PromoCodeRepository, useClass: PromoCodeWebRepository },
  ],
  exports: [
    StoreModule,
  ],
})
export class PromoCodeFeatureModule { }
